<template>
    <div v-if="typeof errors === 'object'" class="md-error">
        <div v-for="error in errors" :key="error">{{ error }}</div>
    </div>
    <span v-else class="md-error">{{ errors }}</span>
</template>

<script>
export default {
    name: "ValidationError",
    props: ["errors"],
};
</script>